module.exports = __webpack_public_path__ + "static/media/logoamex.b8cac5ed.svg";